import Axios from "axios";
var PowerAuthManageService = (function () {
    function PowerAuthManageService() {
    }
    PowerAuthManageService.prototype.getList = function (params) {
        return Axios.get("supplierclientapi/supplier_role/list", { params: params });
    };
    PowerAuthManageService.prototype.create = function (params) {
        return Axios.get("/supplierclientapi/supplier_role/create", { params: params });
    };
    PowerAuthManageService.prototype.update = function (params) {
        return Axios.get("supplierclientapi/supplier_role/update", { params: params });
    };
    PowerAuthManageService.prototype.delete = function (params) {
        return Axios.get("supplierclientapi/supplier_role/delete", { params: params });
    };
    PowerAuthManageService.createInstance = function () {
        PowerAuthManageService.getInstance();
    };
    PowerAuthManageService.getInstance = function () {
        this._instance = new this();
        return this._instance;
    };
    return PowerAuthManageService;
}());
export default PowerAuthManageService;
